import { render, staticRenderFns } from "./TipoRecebimentoManter.vue?vue&type=template&id=01429ae6&"
import script from "./TipoRecebimentoManter.vue?vue&type=script&lang=js&"
export * from "./TipoRecebimentoManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports